export const localStorageKeys = {
  TENANT: 'tenant',
  TENDERING: 'tendering',
  LAYER_DETAILS: 'layerDetails',
};
